import { render, staticRenderFns } from "./OrderStatusForm.vue?vue&type=template&id=1cc5cb94"
import script from "./OrderStatusForm.vue?vue&type=script&lang=js"
export * from "./OrderStatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports